import { render, staticRenderFns } from "./ExemptionApply.vue?vue&type=template&id=5a24ffd8&scoped=true&"
import script from "./ExemptionApply.vue?vue&type=script&lang=js&"
export * from "./ExemptionApply.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionApply.vue?vue&type=style&index=0&id=5a24ffd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24ffd8",
  null
  
)

export default component.exports